import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
import VueApexCharts from 'vue-apexcharts'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { Settings } from 'luxon'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Settings.defaultLocale = 'id'

Vue.component('datetime', Datetime);
Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(plugin)
Vue.use(Loading)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueApexCharts)
Vue.component('Apexchart', VueApexCharts)
Vue.use(VueSweetalert2)
Vue.component('VSelect', vSelect)
Vue.component('Treeselect', Treeselect)
// Vue.component('TDatepicker', TDatepicker)

Vue.filter('formatNumber', function (value) {
  var formatter = new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return formatter.format(value)
})
Vue.filter('titleCase', function (value) {
  return value.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    },
  )
})

Vue.filter('truncate', function (data, num) {
  let reqdString = ''
  let panjang = data.length
  for (let i = 0; i < (num <= panjang ? num : panjang); i++) {
    reqdString += data[i]
  }
  return reqdString + (num < panjang ? '...' : '')
})

InertiaProgress.init({
  delay: 250,
  color: 'red',
  // Whether to include the default NProgress styles.
  includeCSS: true,

  showSpinner: true,
})

const el = document.getElementById('app')

new Vue({
  metaInfo: {
    titleTemplate: title => (title ? `${title} - e-SAKIP` : 'e-SAKIP'),
  },
  render: h =>
    h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
      },
    }),
}).$mount(el)
